import LowerApi from '../modules/lower-api';
import Routes from './routes';
import brand from './brand';
import copy from './copy';
import '../utils/data-dog';

const baseEndpoint = process.env.PLATFORM_API_BASEURL ?? 'PLATFORM_API_BASEURL_ENVTOKEN';

const lowerApi = new LowerApi({
  baseEndpoint,
});

// THEME
const themeName = process.env.DOCUPLOAD_THEME ?? 'DOCUPLOAD_THEME_TOKEN';

function getBrand() {
  const themes = {
    default: brand.DefaultBrand,
    homeside: brand.HomesideBrand,
    lower: brand.LowerBrand,
    lwr: brand.LwrBrand,
    opendoor: brand.OpendoorBrand,
    ozlending: brand.OzLendingBrand,
    powertpo: brand.PowerTpoBrand,
  };

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return (themes[(themeName.toString().toLowerCase()) as keyof typeof themes] || themes.default);
}

function getCopy() {
  const copyOptions = {
    default: copy.DefaultBrand,
    homeside: copy.HomesideBrand,
    lower: copy.LowerBrand,
    lwr: copy.LwrBrand,
    opendoor: copy.OpendoorBrand,
    ozlending: copy.OzLendingBrand,
    powertpo: copy.PowerTpoBrand,
  };

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return (copyOptions[themeName.toString().toLowerCase() as keyof typeof copyOptions] || copyOptions.default);
}
const themeBrand = getBrand();

const copyBrand = getCopy();

const AppConfig = {
  Copy: copyBrand,
  EnableAnimations: true,
  Endpoints: {
    Base: process.env.PLATFORM_API_BASEURL ?? 'PLATFORM_API_BASEURL_ENVTOKEN',
    VerifyUser: `${baseEndpoint}/lending/file_upload_code`,
  },
  LowerApi: lowerApi,
  MaintenanceMode: process.env.MAINTENANCE_MODE ?? '',
  PersistUploads: true,
  Routes,
  SelectedCustomer: themeName.toString().toLowerCase(),
  Theme: themeBrand,
  themeName,
};

export default AppConfig;
